import React from "react";

const DefaultLayout = ({ children }) => <>{children}</>;

export default DefaultLayout;
